export const formatCents = (value?: number | null): string => {
	if (typeof value !== 'number' || Number.isNaN(value)) return '-'
	return `${(value / 100).toFixed(2)} €`
}
